"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_INTENT_VALUES = exports.ONBOARDING_INTENT = exports.MAX_FETCH_ONBOARDING_SCAN_DAYS = exports.MAX_ONBOARDING_SCAN_DAYS = void 0;
/**
 * Maximum number of unique calendar days for onboarding.
 * After this many unique scan days, onboarding is considered complete.
 *
 * @see apps/frontend/src/config/onboardingConfig.ts for the single source of truth
 */
exports.MAX_ONBOARDING_SCAN_DAYS = 3;
// This is the number of days we fetch from the database for onboarding
exports.MAX_FETCH_ONBOARDING_SCAN_DAYS = 8;
/**
 * Onboarding intent — the path the user chose during intent-based onboarding.
 * Stored on the user table for analytics and personalization.
 */
exports.ONBOARDING_INTENT = {
    TREATMENT: 'treatment',
    PRODUCT: 'product',
    LEARN: 'learn',
};
/** Array of all valid onboarding intent values (for Zod enum validation) */
exports.ONBOARDING_INTENT_VALUES = Object.values(exports.ONBOARDING_INTENT);
//# sourceMappingURL=onboarding.js.map